import React, { useContext } from 'react'
import styled from 'styled-components'
import { Avatar, Dropdown, Space, MenuProps } from 'antd'
import { injectIntl } from 'react-intl'
import UserMenu from './UserMenu'
import { UserOutlined } from '@ant-design/icons'
import { UserContext } from '../User/UserContext'

const items: MenuProps['items'] = [
  {
    key: '1',
    type: 'group',
    label: (
      <UserMenu />
    ),
  },
]
  
export const UserDropdown = () => {
  const { userDetails } = useContext(UserContext)

  return (
    <Dropdown menu={{ items }}>
      <Space style={{cursor: 'pointer'}}>
        <UserIcon size={54} icon={<UserOutlined />} src={userDetails.profilePicture} />
      </Space>
    </Dropdown>
  )
}

export default injectIntl(UserDropdown)

const UserIcon = styled(Avatar)`
  cursor: pointer;
  border: 1px solid #ddd;
`